import {
  TypedUseSelectorHook,
  useDispatch as useReduxDispatch,
  useSelector as useReduxSelector,
  useStore as useReduxStore,
} from 'react-redux';

// Typed version of useSelector
export const useSelector: TypedUseSelectorHook<MBStoreState> = useReduxSelector;

// Typed version of useDispatch that properly types the action parameter
// The MBDispatch type uses a generic call signature to preserve discriminated union narrowing
// When you call dispatch({ type: '...', value: {...} }), TypeScript narrows MBAction
// based on the 'type' field and type-checks the 'value' property accordingly
export function useDispatch(): MBDispatch {
  return useReduxDispatch<MBDispatch>();
}

// Typed version of useStore that returns Store<MBStoreState, MBAction>
export function useStore(): MBStore {
  return useReduxStore<MBStoreState, MBAction>();
}
